import { useState } from 'react';

import { useSuspendPrepaidContract } from '../../lib/queries';
import { AppModal } from '../AppModal';

import type { PPItem } from './pp-helpers';

export function PPSuspendModal({
  item,
  companyId,
  onClose,
}: {
  item: PPItem;
  companyId: string | undefined;
  onClose: () => void;
}) {
  const mut = useSuspendPrepaidContract(companyId);
  const [reason, setReason] = useState('');
  const [err, setErr] = useState<string | null>(null);

  function submit() {
    if (!item.apiId) return;
    setErr(null);
    mut.mutate(
      { id: item.apiId, data: { reason } },
      {
        onSuccess: () => onClose(),
        onError: (e) => setErr(e instanceof Error ? e.message : 'พักสัญญาไม่สำเร็จ'),
      },
    );
  }

  return (
    <AppModal
      title={`พักสัญญา — ${item.id}`}
      subtitle="หยุดตัดจ่ายชั่วคราว (ไม่มี JV); เปิดใช้ใหม่แล้วงวดที่ข้ามจะตัดย้อนได้"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn ghost" onClick={onClose}>
            ยกเลิก
          </button>
          <button
            type="button"
            className="btn primary"
            style={{ background: 'var(--warning)' }}
            disabled={mut.isPending || !reason.trim()}
            onClick={submit}
          >
            {mut.isPending ? 'กำลังพัก…' : 'ยืนยันพักสัญญา'}
          </button>
        </>
      }
    >
      <label className="meta">เหตุผล *</label>
      <textarea
        className="input"
        rows={3}
        value={reason}
        placeholder="เช่น รอข้อมูลผู้ขาย / ระงับชั่วคราว"
        onChange={(e) => setReason(e.target.value)}
        style={{ width: '100%', resize: 'vertical', padding: 8 }}
      />
      {err && <div style={{ color: 'var(--negative)', fontSize: 14, marginTop: 8 }}>{err}</div>}
    </AppModal>
  );
}
